import append from '@src/components/modal/__helper__/append';
import * as React from 'react';
import ModalHOC from '@src/components/modal/modal-hoc';
import styles from './extend-append.less';
import cx from 'classnames';

/**
 * 拓展 append 静态方法
 * e.g.
 *
 * @extendAppend
 * export default class Test extends React.Component {
 *   ...
 * }
 *
 * // 此时, Test 组件会被自动注入 append 的静态方法
 *
 * 调用 Test.append(undefined, this) 后即可弹出弹窗
 * 注意: Test.append(<参数1: modal 弹窗 props, 可以自定义拓展部分 props 属性>, <react component 环境变量, 这样可以便于弹窗关闭后自动回收>)
 *
 * @param {string} [staticMethodName] - 静态方法名, 默认: append
 * @param {string} [modalClassName] - 弹窗 css name
 * @param {boolean} [withoutDefaultWrapModal] - 默认情况下 extendAppend 会自动包裹一层 modal, 但用户可以使用参数 withoutDefaultWrapModal 禁用该行为
 * @returns {Function}
 */
const extendAppend = ({ staticMethodName = 'append', modalClassName, withoutDefaultWrapModal } = {}) => ComponentClazz => {
  if (ComponentClazz[staticMethodName]) {
    throw new Error(`target property [${staticMethodName}] 已经存在, 请使用其他静态方法名`);
  }
  ComponentClazz[staticMethodName] = function(props = {}, componentContext) {
    const FinalComponent = ModalHOC({ wrapClassName: cx(modalClassName, styles.extendAppend), withoutDefaultWrapModal })(ComponentClazz);
    return append(appendProps => {
      /**
       * 开发环境
       */
      // if (!DEPLOY_ENV) {
      //   Object.keys(appendProps).forEach(key => {
      //     invariant(props[key] === undefined, `禁止使用保留字段 key = ${key}`);
      //   });
      // }
      return <FinalComponent modal={appendProps} {...props} />;
    }, componentContext);
  };
  return ComponentClazz;
};

export default extendAppend;
